const POLL_ENDPOINTS = {
  // + /:token — GET fetches poll JSON (multi-select "take this poll" link,
  // no side effects) or POST submits the selected options for that token.
  POLL_VOTE: '/public/poll-vote',
};

export default POLL_ENDPOINTS;
